import { useTranslation } from "react-i18next";
import { List } from "semantic-ui-react";

export default function IkarusRateCell(props) {
  const { t } = useTranslation();

  return (
    <div className="flex flex-col items-center justify-center py-2 text-sky-600">
      <h1 className="text-[12px] text-center">{t("ticket_season")}</h1>
      <div className="flex items-center justify-around w-full mt-2">
        <div className="flex flex-col items-center">
          <p className="text-start w-full text-sky-600">{t("ticket_low")}</p>
          <List>
            <List.Item>
              <List.Content>
                <List.Header>{props.passenger_low_season}</List.Header>
                <List.Description className="text-[11px]">
                  {t("passenger")}
                </List.Description>
              </List.Content>
            </List.Item>
            <List.Item>
              <List.Content>
                <List.Header>{props.operator_low_season}</List.Header>
                <List.Description className="text-[11px]">
                  {t("airline")}
                </List.Description>
              </List.Content>
            </List.Item>
          </List>
        </div>
        <div className="flex flex-col items-center">
          <p className="w-full text-end text-sky-600">{t("ticket_high")}</p>
          <List>
            <List.Item>
              <List.Content className="text-end">
                <List.Header>{props.passenger_high_season}</List.Header>
                <List.Description className="text-[11px]">
                  {t("passenger")}
                </List.Description>
              </List.Content>
            </List.Item>
            <List.Item>
              <List.Content className="text-end">
                <List.Header>{props.operator_high_season}</List.Header>
                <List.Description className="text-[11px]">
                  {t("airline")}
                </List.Description>
              </List.Content>
            </List.Item>
          </List>
        </div>
      </div>
    </div>
  );
}